'use strict';

var integrationCallbacks = [];

module.exports = {
    add: function(callback, options) {
        integrationCallbacks.push({
            callback: callback,
            options: options,
        });
    },
    remove: function(callback) {
        integrationCallbacks = integrationCallbacks.filter(function(fn) {
            return fn.callback !== callback;
        });
    },
    call: function(data) {
        return integrationCallbacks.reduce(function(acc, integration) {
            var res = integration.callback(data, integration.options);
            return Object.assign(acc, res);
        }, {});
    },
    reset: function() {
        integrationCallbacks = [];
    },
};
